import { graphql } from "relay-runtime"

export const deDeleteEpisodesOfCareMutation = graphql`
  mutation deDeleteEpisodesOfCareMutation($input: De_deleteEpisodesOfCareInput!, $connections: [ID!]!) {
    deleteEpisodesOfCare: de_deleteEpisodesOfCare(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      de_EpisodeOfCare {
        id @deleteEdge(connections: $connections)
      }
    }
  }
`
